<svg [attr.height]="size" [attr.width]="size" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path [attr.stroke]="color"
        d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
        stroke="#BD2130" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
  <path [attr.stroke]="color" d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
        stroke="#BD2130" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
  <path
    [attr.stroke]="color"
    d="M18.85 9.13965L18.2 19.2096C18.09 20.7796 18 21.9996 15.21 21.9996H8.79002C6.00002 21.9996 5.91002 20.7796 5.80002 19.2096L5.15002 9.13965"
    stroke="#BD2130" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
  <path [attr.stroke]="color" d="M10.33 16.5H13.66" stroke="#BD2130" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="1.5"/>
  <path [attr.stroke]="color" d="M9.5 12.5H14.5" stroke="#BD2130" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="1.5"/>
</svg>
